export default __webpack_public_path__ + "static/6_highflyer-cage-43fca787b6c7e2c6f69c0983bad4eec1.png";